import React, { useState } from "react";

const Avatar = ({ src, name, size = 40, className = "" }) => {
  const [imgError, setImgError] = useState(false);

  const firstLetter = name?.[0]?.toUpperCase() || "?";

  return (
    <div
      className={`rounded-full overflow-hidden bg-green-500 flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      {src && !imgError ? (
        <img
          src={src}
          alt={name || "avatar"}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="text-white font-semibold text-sm">{firstLetter}</span>
      )}
    </div>
  );
};

export default Avatar;
